// Lean fetch-based presign → S3 PUT → Shrine cached-upload JSON helper.
// Mirrors the private getPresignParams/sendFileToS3/formatCachedUpload flow in
// components/input_file/input_file.js, which is deliberately left untouched —
// keep the two in sync if the presign contract ever changes.
// TODO: extract the shared contract (presign request, /cache/ key parsing,
// cached-JSON shape) into one module that both this file and input_file.js
// consume — see the matching TODO above getPresignParams in input_file.js.

function assertOk(response) {
  if (!response.ok)
    throw new Error("Request failed with status " + response.status)
  return response
}

// Uploads `file` through the given Shrine presign endpoint ("/s3/params" for
// private storage, "/s3/public_params" for public) and resolves with the
// cached-upload JSON the app expects in `file:`/`thumbnail:` params.
export function presignAndUpload(file, presignPath) {
  var query = new URLSearchParams({
    filename: file.name,
    type: file.type || "application/octet-stream",
  })

  return fetch(presignPath + "?" + query.toString(), {
    headers: { Accept: "application/json" },
  })
    .then(assertOk)
    .then(function (response) {
      return response.json()
    })
    .then(function (presign) {
      return fetch(presign.url, {
        method: (presign.method || "put").toUpperCase(),
        headers: presign.headers,
        body: file,
      })
        .then(assertOk)
        .then(function () {
          // Both cache and public_cache storages share the "cache" S3 prefix.
          var key = new URL(presign.url).pathname.match(/^\/cache\/(.+)/)[1]
          return {
            id: key,
            storage:
              presignPath.indexOf("public") !== -1 ? "public_cache" : "cache",
            metadata: {
              size: file.size,
              filename: file.name,
              mime_type: file.type,
            },
          }
        })
    })
}
